// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetVillageListRequest,
  TGetVillageListModel,
  IMappers,
  TGetVillageListResponse,
  IGetVillageListResponse,
  IGetVillageListResponseError,
} from './types';

export const defaultConfig: TGetVillageListModel = {
  apiType: 'private',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'countryside-search',
  pathApi: '/v1/get-village-list/',
  requestType: 'json',
} as TGetVillageListModel;

export function createGetVillageListModel(parameters: IGetVillageListRequest): TGetVillageListModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetVillageListOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetVillageListRequest;
}

export async function fetchGetVillageList<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetVillageListOptions<TResponse200, TResponse400>): Promise<TGetVillageListResponse | TResponse200 | TResponse400> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetVillageListModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetVillageListResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetVillageListResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetVillageListResponse;
}
